export const paramaterize = (obj: any) => new URLSearchParams(obj).toString();
